import youtubePlayer from 'youtube-player';

import globals from '../globals';
import helpers from '../helpers';
import header from './header';

const $test = $('.test');
const $start = $test.find('.test__start');
const $container = $test.find('.test__container');
const $step = $test.find('.test__step');
const $result = $test.find('.test__result');
const $button = $test.find('.test__button');
const $answer = $test.find('.test__answer');
const $count = $test.find('.test__count');
const $sound = $test.find('.test__sound');
const $audio = $sound.find('audio');
const $movie = $test.find('.test__movie');

let correctAnswersCount = 0;

function stopVideo() {
	$movie.each((index, movie) => {
		const player = $(movie).data('player');

		if (!player) {
			return;
		}

		player.stopVideo();
	});
}

function playVideo() {
	const $currentResult = $result.filter('.is-active');

	if (!$currentResult.length) {
		return;
	}

	const $currentMovie = $currentResult.find('.test__movie');

	if (!$currentMovie.length) {
		return;
	}

	const player = $currentMovie.data('player');

	if (!player) {
		return;
	}

	player.playVideo();
}

function initVideo() {
	$movie.each((index, movie) => {
		const $currentMovie = $(movie);

		$currentMovie.html('<div></div>');

		const player = youtubePlayer($currentMovie.find('div').get(0), {
			width: '100%',
			height: '100%',
			videoId: $currentMovie.data('test-movie'),
			playerVars: {
				playsinline: 1,
				rel: 0,
			},
		});

		$currentMovie.data('player', player);

		let playInterval = null;

		player.on('stateChange', (e) => {
			const currentState = e.data;

			if (currentState === 0) {
				clearInterval(playInterval);

				globals.$document.trigger('analytics-video-finish', [$currentMovie]);
			} else if (currentState === 1) {
				clearInterval(playInterval);

				playInterval = setInterval(() => {
					globals.$document.trigger('analytics-video-timing', [$currentMovie]);
				}, 10000);

				globals.$document.trigger('analytics-video-play', [$currentMovie]);
			} else if (currentState === 2) {
				clearInterval(playInterval);
			}
		});
	});
}

function stopAudio() {
	$audio.each((index, audio) => {
		audio.pause();
		audio.currentTime = 0;
	});
}

function playAudio() {
	const $currentStep = $step.filter('.is-active');

	if (!$currentStep.length) {
		return;
	}

	const $currentAudio = $currentStep.find('audio');

	if (!$currentAudio.length) {
		return;
	}

	$currentAudio
		.get(0)
		.play();
}

function addAnswerIcon($currentAnswer) {
	let type = null;

	if ($currentAnswer.hasClass('is-right')) {
		type = 'right';
	} else if ($currentAnswer.hasClass('is-wrong')) {
		type = 'wrong';
	} else {
		return;
	}

	$currentAnswer.prepend(`
		<div class="test__icon test__icon--${type}">
			<svg><use xlink:href="./images/sprites.svg#${type}"></use></svg>
		</div>
	`);
}

function repeat() {
	correctAnswersCount = 0;

	$start.addClass('is-active');
	$step.removeClass('is-active is-done');
	$result.removeClass('is-active');

	$answer
		.removeClass('is-right is-wrong')
		.find('.test__icon')
		.remove();

	$count.empty();

	stopVideo();

	globals.$document.trigger('analytics-test-resume');
}

function result() {
	let resultIndex = null;

	if (correctAnswersCount <= 3) {
		resultIndex = 1;
	} else if (correctAnswersCount >= 4 && correctAnswersCount <= 5) {
		resultIndex = 2;
	} else if (correctAnswersCount >= 6) {
		resultIndex = 3;
	}

	const $currentResult = $result.filter(`[data-test-result="${resultIndex}"]`);
	const $currentCount = $currentResult.find('.test__count');

	$currentCount.html(`<b>${correctAnswersCount}</b>/${$step.length}`);
	$step.removeClass('is-active');
	$currentResult.addClass('is-active');

	stopAudio();
	playVideo();

	globals.$document.trigger('analytics-test-finish');
}

function next() {
	globals.$document.trigger('analytics-test-question-answer');

	const $activeStep = $step.filter('.is-active');
	const $nextStep = $activeStep.next('.test__step');

	if (!$nextStep.length) {
		result();

		return;
	}

	$activeStep.removeClass('is-active');
	$nextStep.addClass('is-active');

	stopAudio();
	playAudio();

	globals.$document.trigger('analytics-test-question-show');
}

function start() {
	$start.removeClass('is-active');

	$step
		.removeClass('is-active')
		.filter('[data-test-step="1"]')
		.addClass('is-active');

	playAudio();

	globals.$document.trigger('analytics-test-start');
	globals.$document.trigger('analytics-test-question-show');
}

function changeState(e) {
	e.preventDefault();
	e.stopPropagation();

	const type = e.currentTarget.dataset.testButton;

	if (type === 'start') {
		start();
	} else if (type === 'next') {
		next();
	} else if (type === 'repeat') {
		repeat();
	} else {
		return;
	}

	helpers.scrollTo($container.offset().top - header.getHeight() - 20);
}

function selectAnswer(e) {
	const $currentAnswer = $(e.currentTarget);
	const $currentStep = $currentAnswer.closest('.test__step');
	const $currentList = $currentStep.find('.test__list');

	if ($currentStep.hasClass('is-done')) {
		return;
	}

	$currentStep.addClass('is-done');

	if ($currentAnswer.hasClass('is-correct')) {
		correctAnswersCount++;

		$currentAnswer.addClass('is-right');

		addAnswerIcon($currentAnswer);
	} else {
		const $correctAnswer = $currentAnswer.siblings('.test__answer.is-correct');

		$currentAnswer.addClass('is-wrong');
		$correctAnswer.addClass('is-right');

		addAnswerIcon($currentAnswer);
		addAnswerIcon($correctAnswer);
	}

	helpers.scrollTo($currentList.offset().top - header.getHeight() - 20);
}

function changeSoundState() {
	$sound.toggleClass('is-muted');

	const isMuted = $sound.hasClass('is-muted');

	$audio.each((index, audio) => {
		audio.muted = isMuted;
	});
}

function init() {
	initVideo();

	$button.on('click.test', changeState);
	$answer.on('click.test', selectAnswer);
	$sound.on('click.test', changeSoundState);
}

init();
